import { Component, OnInit, AfterViewChecked, ElementRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BackgroundCheck } from '../../models/BackgroundCheck';
import { Application } from '../../models/application';
import { ApplicationDataService } from '../../../services/application.service';
import { Property } from '../../models/property';
import { EventEmitterService } from 'services/event-emitter.service';
import { SplashService } from 'services/splash.service';
import { environment } from '../../../environments/environment';
import { ErrorService } from 'services/error.service';
import { ApplicationInterface } from 'app/interface/application';
import { AnalyticsService } from 'services/analytics.service';
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {
  InvestigativeConsumerReportComponent
} from "./investigative-consumer-report/investigative-consumer-report.component";

@Component({
  selector: 'app-background-check',
  templateUrl: './background-check.component.html',
  styleUrls: ['./background-check.component.css']
})

export class BackgroundCheckComponent implements OnInit, AfterViewChecked {
  @ViewChild('backgroundCheck', { static: true }) private myScrollContainer: ElementRef;
  errorMessage: string;
  showTerms: boolean;
  checkboxValue: boolean;
  model: BackgroundCheck;
  RentalApplicationKey: number;
  RentalApplicantKey: number;
  AddAdditionalApplicantKey: number = null;
  AddAdditionalApplicantName: string = null;
  CompletedByOther: boolean = false;
  modelProperty: Property;
  splashHTML: string;
  termsOfAgreementUrl = environment.termsOfAgreementUrl;
  hasRentableItems: boolean;
  totalApplicationSteps: number = 8;
  currentApplicationStep: number = 6;
  verifastEnabled: boolean;

  constructor(
    private applicationService: ApplicationDataService,
    public router: Router,
    public route: ActivatedRoute,
    private eventEmitterService: EventEmitterService,
    private splashService: SplashService,
    private errorService: ErrorService,
    private readonly analyticsService: AnalyticsService,
    public investigativeConsumerReportDialog: MatDialog,) {
      this.analyticsService.track(
        'HRA Application',
        'Background Check',
        'Start',
        'Start',
        '',
        this.additionalAnalyticsDetails());
    const RentalApplicationKey = localStorage.getItem('RentalApplicationKey');
    const RentalApplicantKey = localStorage.getItem('RentalApplicantKey');

    const AddAdditionalApplicantKey = localStorage.getItem('AddAdditionalApplicantKey');
    const AddAdditionalApplicantName = localStorage.getItem('AddAdditionalApplicantName');

    const correctStatus = localStorage.getItem('CorrectStatus');

    if (correctStatus != "true") {
      localStorage.removeItem('RentalApplicationKey');
      this.analyticsService.track(
        'HRA Application',
        'Background Check',
        'Stop',
        'Application not in the correct status',
        '/application/dashboard',
        this.additionalAnalyticsDetails());
      this.router.navigate(['/application/dashboard']);
    }

    if (AddAdditionalApplicantKey !== null && AddAdditionalApplicantKey !== undefined) {
      this.AddAdditionalApplicantKey = Number(AddAdditionalApplicantKey);
    }

    if (AddAdditionalApplicantKey !== null && AddAdditionalApplicantKey !== undefined) {
      this.AddAdditionalApplicantName = AddAdditionalApplicantName
    }

    this.eventEmitterService.splashChangeEmitted$.subscribe(res => this.updateSplashHTML(res));
    this.splashService.updateSplash("apply");

    if (RentalApplicationKey !== undefined && RentalApplicationKey !== null &&
      RentalApplicantKey !== undefined && RentalApplicantKey !== null) {

      this.RentalApplicationKey = Number(RentalApplicationKey);
      this.RentalApplicantKey = Number(RentalApplicantKey);

      this.applicationService.getBackgroundCheck(RentalApplicationKey, RentalApplicantKey, AddAdditionalApplicantKey)
        .subscribe(res => this.getBackgroundCheck(res), err => this.onGetBackgroundCheckError(err));

    } else {
      this.analyticsService.track(
        'HRA Application',
        'Background Check',
        'Stop',
        'Application or applicant not in the right state',
        '/application/basic',
        this.additionalAnalyticsDetails());
      this.router.navigate(['/application/basic']);
    }
  }

  private additionalAnalyticsDetails(): any {
    try {
      return { };
    } catch (error) {
      console.error(error);
      return {};
    }
  }

  updateSplashHTML(res: string) {
    this.splashHTML = res;
  }

  getBackgroundCheck(BackgroundCheck: BackgroundCheck) {
    this.model = BackgroundCheck;

    this.model.RentalApplicationKey = this.RentalApplicationKey;

    let AddAdditionalApplicantKey = localStorage.getItem('AddAdditionalApplicantKey');
    if (AddAdditionalApplicantKey !== null && AddAdditionalApplicantKey !== undefined) {
      this.CompletedByOther = true;
      this.model.RentalApplicantKey = this.AddAdditionalApplicantKey;
    }
    else {
      this.CompletedByOther = false;
      this.model.RentalApplicantKey = this.RentalApplicantKey;

    }

  }

  onGetBackgroundCheckError(message: string) {
    this.errorService.showError(message);
  }

  ngOnInit() {
    const rentableItems = localStorage.getItem('hasRentableItems');
    const verifastEnabled = localStorage.getItem('verifastEnabled');
    const hasAncillaryItems = localStorage.getItem('HasAncillaryItems');
    if ((rentableItems && rentableItems === 'true') || (hasAncillaryItems && hasAncillaryItems === 'true')) {
      this.hasRentableItems = true;
      this.totalApplicationSteps = 9;
    }

    if (verifastEnabled && verifastEnabled === 'true') {
      this.verifastEnabled = true;
      this.totalApplicationSteps++;
      this.currentApplicationStep++;
    }

    const property = JSON.parse(localStorage.getItem('SelectedProperty'));
    if (property != null) {
      this.modelProperty = property[0];
      if ((property[0].min_rent != null && property[0].max_rent != null) && (property[0].min_rent == property[0].max_rent)) {
        this.modelProperty.rent = property[0].min_rent.toLocaleString();
      }
      else if (property[0].min_rent != null && property[0].max_rent != null) {
        this.modelProperty.rent = property[0].min_rent.toLocaleString() + '-$' + property[0].max_rent.toLocaleString()
      }
    }
  }

  ngAfterViewChecked() {
    this.scrollToBottom();
  }

  scrollToBottom(): void {
    try {
      this.myScrollContainer?.nativeElement.scrollIntoView(false);
    } catch (err) { console.log('error: ' + err); }
  }

  onShowTermsClick() {
    // this.showTerms = true;
    window.open(this.termsOfAgreementUrl, '_blank');
  }

  cancelEdit() {
    localStorage.removeItem('AddAdditionalApplicantKey');
    localStorage.removeItem('AddAdditionalApplicantName');
    this.analyticsService.track(
      'HRA Application',
      'Background Check',
      'Stop',
      'Cancelling edit',
      '/application/applicants',
      this.additionalAnalyticsDetails());
    this.router.navigate(['/application/applicants']);
  }

  onSubmit() {
    this.applicationService.updateBackgroundCheck(this.model, this.CompletedByOther)
      .subscribe(res => this.onUpdateSuccess(res), err => this.backgroundCheckError(err));
  }

  backgroundCheckError(err: any) {
    this.errorService.showError(err);
  }

  onUpdateSuccess(BackgroundCheck: BackgroundCheck) {
    // check if primary applicant
    if (BackgroundCheck instanceof Object) {
      this.applicationService.getCurrentApplication(this.model.RentalApplicationKey)
        .subscribe(res => this.onUpdateSuccessNavigate(res));
    }
  }

  onUpdateSuccessNavigate(Application: Application) {
    localStorage.removeItem('AddAdditionalApplicantKey');
    localStorage.removeItem('AddAdditionalApplicantName');
    this.router.navigate(['/application/applicants']);
  }

  showInvestigativeConsumerReportDialog() {
    this.investigativeConsumerReportDialog.open(InvestigativeConsumerReportComponent, new MatDialogConfig());
  }

}
